import { useEffect } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';

import { ERROR_PATH, ROOT_PATH } from 'shared/consts';
import { useViewParams } from 'hooks/use-view-params.hook';

export const VisitorRegistrationRoot = (): JSX.Element => {
  const { buildingUuid } = useViewParams() || {};
  const navigate = useNavigate();

  useEffect(() => {
    if (!buildingUuid) {
      navigate(ERROR_PATH, { replace: true });
    } else {
      const targetUrl = `${generatePath(ROOT_PATH, { ownerId: buildingUuid, ownerType: 'building' })}`;
      navigate(targetUrl, { replace: true });
    }
  }, [buildingUuid, navigate]);

  return null;
};
